const buttonModalEquipService = {
  text: 'adicionar seção'
};

export default buttonModalEquipService;
